module.exports = __webpack_public_path__ + "img/certif_015.8b88f7d0.jpg";